import { useResetRecoilState, useSetRecoilState } from "recoil"
import quizPhaseState from "../../recoil/quizPhase"
import quizPreinfoState from "../../recoil/quizPreinfo"
import { useEffect } from "react"
import { toast } from "react-toastify"
import { quizResponseListState } from "../../recoil/QuizPage/atoms"
import { QuizResponseType } from "../../types"

const useSavedQuizData = () => {
  const setQuizPhase = useSetRecoilState(quizPhaseState)
  const resetQuizPhase = useResetRecoilState(quizPhaseState)

  const setQuizPreinfo = useSetRecoilState(quizPreinfoState)
  const resetQuizPreinfo = useResetRecoilState(quizPreinfoState)

  const setQuizResponseList = useSetRecoilState(quizResponseListState)
  const resetQuizResponseList = useResetRecoilState(quizResponseListState)

  useEffect(() => {
    const loadQuizData = (preinfo: any, progress: any, response: any) => {
      setQuizPreinfo(preinfo)
      if (response) {
        setQuizResponseList(response)
      }
      setQuizPhase("main")
    }

    const resetQuizData = () => {
      resetQuizPreinfo()
      resetQuizResponseList()
      localStorage.removeItem("quizPreinfo")
      localStorage.removeItem("quizProgress")
      localStorage.removeItem("quizResponseList")
    }

    resetQuizPhase()
    const savedPreinfo = localStorage.getItem("quizPreinfo")
    const savedProgress = localStorage.getItem("quizProgress")
    const savedResponseList = localStorage.getItem("quizResponseList")
    if (savedPreinfo && savedProgress) {
      const parsedPreinfo = JSON.parse(savedPreinfo)
      const parsedProgress = JSON.parse(savedProgress)
      let parsedResponseList: QuizResponseType[]
      if (savedResponseList) {
        console.log(savedResponseList)
        parsedResponseList = JSON.parse(savedResponseList)
      }

      if (parsedPreinfo.major !== "") {
        toast.dismiss()
        toast(
          <div>
            <p>진행 중이던 내용이 있습니다. 이어하시겠습니까?</p>
            <button
              onClick={() =>
                loadQuizData(parsedPreinfo, parsedProgress, parsedResponseList)
              }
            >
              이어하기
            </button>
            <button onClick={resetQuizData}>새로하기</button>
          </div>,
          {
            position: "top-right",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        )
      } else {
        resetQuizData()
      }
    } else {
      localStorage.clear()
    }
  }, [
    resetQuizPhase,
    resetQuizPreinfo,
    resetQuizResponseList,
    setQuizPhase,
    setQuizPreinfo,
    setQuizResponseList,
  ])
}

export default useSavedQuizData
